import { render, staticRenderFns } from "./SubscribedSettings.vue?vue&type=template&id=d6d6455c&scoped=true"
import script from "./SubscribedSettings.vue?vue&type=script&lang=js"
export * from "./SubscribedSettings.vue?vue&type=script&lang=js"
import style0 from "./SubscribedSettings.vue?vue&type=style&index=0&id=d6d6455c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d6455c",
  null
  
)

export default component.exports